import { render, staticRenderFns } from "./ShopMenu.vue?vue&type=template&id=132d34ad&scoped=true&"
import script from "./ShopMenu.vue?vue&type=script&lang=js&"
export * from "./ShopMenu.vue?vue&type=script&lang=js&"
import style0 from "./ShopMenu.vue?vue&type=style&index=0&id=132d34ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d34ad",
  null
  
)

export default component.exports